/* Sponsorship form.
   Shopify's customer form only accepts a fixed set of fields, so the survey answers cannot each be
   their own input. Instead every answer is collected on submit and written into contact[note], and
   any answer flagged as a tag is appended to contact[tags]. The visible fields carry no name
   attribute, so nothing unexpected is posted. */
(function () {
  function init(form) {
    if (form.__sponInit) return;
    form.__sponInit = true;

    var noteEl = form.querySelector('[data-spon-note]');
    var tagsEl = form.querySelector('[data-spon-tags]');
    if (!noteEl) return;

    var baseTags = tagsEl ? (tagsEl.value || '') : '';

    form.addEventListener('submit', function () {
      var fields = Array.prototype.slice.call(form.querySelectorAll('[data-spon-q]'));
      var lines = [];
      var tags = baseTags ? baseTags.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];

      fields.forEach(function (el) {
        var q = el.getAttribute('data-spon-q') || '';
        var v = (el.value || '').trim();
        if (!v) return;
        lines.push(q + ': ' + v);
        if (el.hasAttribute('data-spon-tag')) {
          var clean = v.replace(/[,]/g, ' ').trim();
          if (clean && tags.indexOf(clean) === -1) tags.push(clean);
        }
      });

      noteEl.value = lines.join('\n');
      if (tagsEl) tagsEl.value = tags.join(', ');
    });
  }

  function boot() {
    document.querySelectorAll('.apx-spon__form').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
